
import React, {useState} from 'react';
import {asyncRequestCompanyInfo} from "../net/QBOCalls";

export default function TestCompanyInfo() {

    const [state, setState] = useState({
        value: 0
    });

    function handleCompanyInfo(info) {

        const copy = { ...state };
        copy.value = 1;

        setState(copy);
    }

    function handleError(error) {
        console.warn(error);
    }

    switch(state.value) {
        case 0:
            asyncRequestCompanyInfo(handleCompanyInfo, handleError);
            break;
        case 1:
            console.warn(state);
            break;
        default:
            console.warn("State invalid");
            break;
    }

    return (
        <React.Fragment>

        </React.Fragment>
    )
}